import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../util';

import { OutcomeService, OutcomeData, OutcomedBill, OutcomeBill, Outcome } from '../../services/outcome.service';
import { SupplierBillService, SupplierBillData, ChargeNote, Outcomed, SupplierBill, SupplierBillId } from '../../services/supplier-bill.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { FiscalDataService } from '../../services/fiscal-data.service';
import { BankService, BankData } from '../../services/bank.service';

import { ISubscription, Subscription } from "rxjs/Subscription";

@Component({
  selector: 'app-update-outcome',
  templateUrl: './update-outcome.component.html',
  styleUrls: ['./update-outcome.component.css']
})
export class UpdateOutcomeComponent implements OnInit, OnDestroy {

  outcomeId: string;
  supplierId: string;
  supplierName: string = '';
  fiscalDataId: string;
  fiscalDataName: string = '';

  form: FormGroup;
  folio: number;
  payMethodSelect: any[];

  pickadateParams = Utils.pickadateParams();

  subs = [];

  constructor(
    private service: OutcomeService,
    private outcomeData: OutcomeData,
    private supplierBillService: SupplierBillService,
    private supplierBillData: SupplierBillData,
    private supplierService: CustomerSupplierService,
		private fiscalDataService: FiscalDataService,
    private bankService: BankService,
    private bankData: BankData,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.outcomeId = activatedRoute.snapshot.paramMap.get('id');
    this.supplierId = this.activatedRoute.snapshot.paramMap.get('supplierId');
    this.fiscalDataId = this.activatedRoute.snapshot.paramMap.get('fiscalDataId');

    this.payMethodSelect = Object.keys(outcomeData.statusObjects).map(key => ({value: key, ...outcomeData.statusObjects[key]}) );

    this.subs.push(
      this.supplierService.getCustomerSupplier(this.supplierId).subscribe(c => {console.log(c); this.supplierName = c.name })
    );
    this.subs.push(
      this.fiscalDataService.getFiscalData(this.fiscalDataId).subscribe(fd => { this.fiscalDataName = fd.businessName })
    );

    this.banks = {};
    this.subs.push(
      this.bankService.getBanks().subscribe(banks => {
        this.rowsRead[0] = banks.filter(bank => {
          bank.name = bank.accountNumber;
          bank.currency = this.bankData.currencies[bank.currency].fullName;
          this.banks[bank.id] = {...bank};
          if(bank.isOutcome) return bank;
        });
      })
    );

    this.subs.push(
      this.supplierBillService.getSupplierBills().subscribe(supplierBills => {
        this.outcomedBills = supplierBills.filter(supplierBill => {
          return !supplierBill.canceled && !!supplierBill.total && supplierBill.fiscalDataRef.id == this.fiscalDataId;
        }).map(supplierBill => {
          let obj = new OutcomedBill(supplierBill, this.outcomeId);
          if(!(obj.isComplete && !obj.lastAmount)) return obj;
        }).filter(t=>t);
      })
    );
  }

  ngOnInit() {
    this.createForm();
    this.subs.push(
      this.service.getOutcome(this.outcomeId).subscribe(([outcome]) => {
        this.form.patchValue(outcome);
        this.selectedBankId = outcome.bankObj.id;
      })
    );
  }
	ngOnDestroy() {
    this.subs.map((sub,index) => {
      this.subs[index].unsubscribe();
    });
  }

  createForm(){
    this.form = this.fb.group({
      date: [this.today, Validators.required],
      amount: [0, [Validators.required, Validators.min(0)]],
      payMethod: [this.payMethodSelect[0].value, Validators.required],
      reference: '',
      notes: ''
    });
  }

  onSubmit({ value, valid }: { value: any, valid: any }){

    value.supplierRef = this.supplierId;
    value.fiscalDataRef = this.fiscalDataId;
    value.bankRef = this.selectedBankId;
    value.bills = this.outcomedBills.filter(bill => !!bill.amount).map(outcomedBill => outcomedBill.databaseObject);
    
    this.service.updateOutcome(this.outcomeId, value);
    this.updateSupplierBills();
    this.service.windowReplace('read');
  }
  
  updateSupplierBills(){
    let outcomeRef = this.supplierBillService.afhService.doc(`${this.service.collection}/${this.outcomeId}`).ref;
    this.outcomedBills.map(({supplierBill, amount=0}: {supplierBill: SupplierBillId, amount: number}) => {
      supplierBill.outcomeds = supplierBill.outcomeds.filter(outcomed => outcomed.outcomeRef.id != this.outcomeId);
      if(amount) supplierBill.outcomeds.push({outcomeRef, amount});
      this.supplierBillService.updateByField({outcomeds: supplierBill.outcomeds}, supplierBill.id);
    });
  }


  stringifyDate(date: Date){
    var dd:string = date.getDate() + '';
    var mm:string = date.getMonth()+ 1 + '';
    var yyyy = date.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }

  money = Utils.money;

  get today(){
    return this.stringifyDate(new Date());
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  
  //Bank
  banks: any = {};
  selectedBankId: string = '';
  get readValid(){ return this.selectedBankId };

  currentReadIndex: number;
  rowsRead = [[]];
  columnsRead = [
    [
      { title: 'Número de cuenta', name: 'name' },
      { title: 'Banco', name: 'bankName' },
      { title: 'CLABE', name: 'CLABE' },
      { title: 'Moneda', name: 'currency' }
    ]
  ]

  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.data = this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead({row}): any{
    if(this.currentReadIndex == 0) this.selectedBankId = row.id;
    this.closeModalRead();
  }


  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

  //////////////////////////////////////////////////////////////////////////////////////////////CUSTOMER BILL
  outcomedBills: OutcomedBill[] = [];
  get outcomedBillsTotal(): number {
    return this.outcomedBills.reduce((total, outcomedBill) => total + outcomedBill.amount, 0);
  }
  get outcomedBillsTotalIsValid(): boolean {
    return Math.floor(this.outcomedBillsTotal) == Math.floor(this.form.get('amount').value) && this.outcomedBillsTotal >= 0;
  }
  get allOutcomeBillsValid(): boolean {
    return this.outcomedBills.find(bill => !bill.isValid) == undefined;
  }
  //////////////////////////////////////////////////////////////////////////////////////////////CUSTOMER BILL
}